/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Nahrazovač úloh a časovačů pro vypnutí a zapnutí zařízení
 *
 * Stará se o aktualizaci časovačů zařízení dle obsahu datového skladu.
 */
class ReplacerPower {
  /**
   * Vytvoří nahrazovač časovačů.
   * @param {PowerManager} powerManager
   */
  constructor(powerManager) {
    this.powerManager = powerManager;
  }

  /**
   * Změní časovače zařízení dle datového skladu.
   * @param {ContentInfo} contentInfo
   * @returns {Promise.<undefined>} Vyřeší se po dokončení přeplánování.
   */
  replace(contentInfo) {
    return new Promise((resolve) =>
      resolve(
        // Odstraní se všechny nastavené časovače.
        this.powerManager
          .deleteAllTimers()
          // Nastaví se nové časovače.
          .then(() =>
            this.powerManager.createTimers(
              contentInfo.powerTasks,
              contentInfo.timerArray
            )
          )
      )
    );
  }
}

export default ReplacerPower;
